'use client';

import { useCallback, useEffect, useRef } from 'react';

import { GTMPromotion, sendViewPromotion } from '../utils/bannerPromotion';

export const useGTMViewPromotionItemRef = (
  getPromotion: (index: number) => GTMPromotion | undefined
) => {
  const sentIndices = useRef(new Set<number>());
  const observers = useRef(new Map<number, IntersectionObserver>());

  const bannerRef = useCallback(
    (index: number, element: HTMLElement | null) => {
      observers.current.get(index)?.disconnect();
      observers.current.delete(index);

      if (!element || sentIndices.current.has(index)) return;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting || sentIndices.current.has(index)) return;

          const promotion = getPromotion(index);
          if (!promotion) return;

          sentIndices.current.add(index);
          observer.disconnect();
          observers.current.delete(index);

          sendViewPromotion(promotion);
        },
        { threshold: 0.5 }
      );

      observer.observe(element);
      observers.current.set(index, observer);
    },
    [getPromotion]
  );

  useEffect(
    () => () => {
      observers.current.forEach((observer) => observer.disconnect());
      observers.current.clear();
    },
    []
  );

  return bannerRef;
};
